var v1="<section> <h3 ng-if=\"vm.settings.displayName\">{{ vm.settings.displayName }}</h3> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> <div ng-repeat=\"item in vm.settings.children track by $index\"> <div lba-dynamic=\"'lba-' + item.displayAs\" settings=\"item\"></div> </div> </section>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaGroup/lbaGroup.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaGroup/lbaGroup.html
// module id = 210
// module chunks = 0